import { useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw, Inbox } from "lucide-react";
import { authHeader } from "../../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EnquiriesList = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/enquiries`, { headers: authHeader() });
      setEnquiries(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-serif text-xl text-[#121926]">Client Enquiries</h2>
        <button onClick={load} data-testid="admin-refresh-button" className="inline-flex items-center gap-2 px-4 py-2 border border-[#1A2533]/25 text-xs text-[#1A2533] hover:border-[#B85D2A] hover:text-[#B85D2A] transition-colors">
          <RefreshCw size={13} className={loading ? "animate-spin" : ""} /> Refresh
        </button>
      </div>
      {!loading && enquiries.length === 0 && (
        <div className="bg-white border border-[#E3DED4] p-14 text-center" data-testid="admin-empty-state">
          <Inbox size={32} className="mx-auto text-[#B85D2A]" strokeWidth={1.25} />
          <p className="mt-4 text-[#4A5568]">No enquiries yet.</p>
        </div>
      )}
      <div className="space-y-4">
        {enquiries.map((e) => (
          <div key={e.id} className="bg-white border border-[#E3DED4] p-6" data-testid="admin-enquiry-row">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <p className="font-serif text-lg text-[#121926]">{e.full_name}</p>
                <p className="text-sm text-[#526071] mt-1">
                  <a href={`mailto:${e.email}`} className="hover:text-[#B85D2A]">{e.email}</a>
                  {e.phone ? ` · ${e.phone}` : ""}
                </p>
              </div>
              <div className="text-right">
                <span className="inline-block px-3 py-1 bg-[#F2ECE2] text-[#7C5333] text-xs font-medium">{e.service_type}</span>
                <p className="mt-2 font-mono text-[11px] text-[#8A94A2]">{new Date(e.created_at).toLocaleString()} · {e.language.toUpperCase()}</p>
              </div>
            </div>
            {e.timeline && <p className="mt-3 text-xs font-mono uppercase tracking-wider text-[#8C6B4F]">Timeline: {e.timeline}</p>}
            <p className="mt-3 text-sm text-[#4A5568] leading-relaxed border-t border-[#EDEAE1] pt-3">{e.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
